import { render, staticRenderFns } from "./EbisStudentApplicationForm.vue?vue&type=template&id=665fc60a"
import script from "./EbisStudentApplicationForm.vue?vue&type=script&lang=js"
export * from "./EbisStudentApplicationForm.vue?vue&type=script&lang=js"
import style0 from "./EbisStudentApplicationForm.vue?vue&type=style&index=0&id=665fc60a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports